import {
  AccountCircleOutlinedIcon,
  AddCircleOutlineIcon,
  ViewStoryIcon,
} from '@weblite/icons'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Localization
import { t } from '$i18n'
import {
  ContextMenuItem,
  ContextMenuList,
} from '$comp/_app/components/chat/components/body/components/context-menu/components'

export interface RoomProfileMenuProps {
  isOpen: boolean
  xAxis: number
  yAxis: number
  hasStory: boolean
  onProfileClick: (e: MouseEvent<HTMLDivElement>) => void
  onStoryClick: (e: MouseEvent<HTMLDivElement>) => void
}
export function RoomProfileMenu({
  isOpen,
  hasStory,
  yAxis,
  xAxis,
  onStoryClick,
  onProfileClick,
}: RoomProfileMenuProps) {
  return (
    <ContextMenuList
      xAxis={xAxis}
      yAxis={yAxis}
      open={isOpen}
      onClose={closeCurrentModal}
    >
      <ContextMenuItem
        text={t('menu.roomProfile.viewProfile')}
        onClick={onProfileClick}
      >
        <AccountCircleOutlinedIcon sx={{ color: 'neutral800' }} />
      </ContextMenuItem>

      <ContextMenuItem
        text={hasStory ? t('menu.roomProfile.viewStory') : t('story.addStory')}
        onClick={onStoryClick}
      >
        {hasStory ? (
          <ViewStoryIcon sx={{ color: 'neutral800' }} />
        ) : (
          <AddCircleOutlineIcon sx={{ color: 'neutral800' }} />
        )}
      </ContextMenuItem>
    </ContextMenuList>
  )
}
